module.exports = __webpack_public_path__ + "img/Shopee-logo.9822cf1e.png";